import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Contact } from '../../../Models/Session';
import { AuthService } from '../../../Services/auth.service';
import { BaseApiService } from '../../../Services/base-api.service';
import { RichTextEditorService } from '../../../Services/rich-text-editor.service';



@Component({
  selector: 'app-show-contacts',
  templateUrl: './show-contacts.component.html',
  styleUrls: ['./show-contacts.component.css'],standalone:false
})
export class ShowContactsComponent implements OnInit {


  sessionDataArray: Contact[] = [];
  loading:boolean=false;

  constructor
  (
    private api:BaseApiService,
    private auth:AuthService,
    private editorService: RichTextEditorService,
    private http:HttpClient,private messageService:MessageService,private fb: FormBuilder)
  {

  }
  getdat(){
    this.loading=true;
    this.api.read("ContactPage").subscribe
    (
      (response)=>{
        this.sessionDataArray = response;
        this.loading=false;
      }
      ,(
        error
      )=>{
        this.loading=false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
    )
  }
  ngOnInit(): void {

    this.getdat();



   }






}
